var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"text-h1 mb-6 mt-10"},[_vm._v("Error in authentication")])])
}]

export { render, staticRenderFns }